module.exports = __webpack_public_path__ + "img/b468f92a4a779d137f3a5bb19f50f939.png";